<template lang='pug'>
    div
        PDaccessoriesSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")

            section.title-container
                h1.product-title Sensor Cases
                h2.product-subtitle Hard-carry-case for drain valve UHF sensors

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/for_product_overview/SensorCase.webp')
                            img( src='@/assets/photos/for_product_overview/SensorCase.png', width="70%", alt='Sensor Case for UHF Sensors', title='Sensor Case for UHF Sensors')
                        
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Protection for UHF Sensors
                                li Various configurations possible
                            
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet UHF-Case-2DN5080.pdf")
                            Maillink(to='support@bss-hs.de', sub='Sensor Case', text='Contact Us', size=30, strokeWidth=2)
                            Sitelink(to="/en/products/uhfsensors/overview", text='UHF Sensors')
                        

        div.fullwidth(v-if="$route.params.lang == 'de'")

            section.title-container
                h1.product-title Tragekoffer für UHF-Sensoren
                h2.product-subtitle Hartschalentragekoffer für Schiebesensoren

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/for_product_overview/SensorCase.webp')
                            img( src='@/assets/photos/for_product_overview/SensorCase.png', width="70%", alt='Sensorkoffer für UHF-Sensoren', title='Sensorkoffer für UHF-Sensoren')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Schutzkoffer für UHF-Sensoren
                                li Verschiedene Konfigurationen möglich
                            
                        .bluebox
                            Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet UHF-Case-2DN5080.pdf")
                            Maillink(to='support@bss-hs.de', sub='Sensor Case', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/uhfsensors/overview", text='UHF-Sensoren')
                        
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | Sensorkoffer",
            description: "Tragekoffer für UHF-Schiebesensoren",
        },
        en: {
            title: "BSS | UHF Sensor Case",
            description: "Hard-carry-case for Drain Valve UHF Sensors",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>